/* =========================================================
   LINKS — los botones con data-link="..." toman su URL de acá.
   Los de compra también la tienen escrita en index.html, así
   funcionan aunque en la tienda haya una versión vieja de este archivo.
   ========================================================= */
const LINKS = {
  coleccion: "https://mocilab.com/collections/icoins-collection-fc-barcelona-26-27", // "Empezar la colección" (banner): sobres y monedas
  album:     "https://mocilab.com/products/album-premium-icoins-collection-fc-barcelona", // "Comprar el álbum premium — 10,95 €"
  caja:      "https://mocilab.com/products/pack-5-sobres-icoins-collection-fc-barcelona", // "Comprar Cajas" / "Comprar caja de 5 — 14,95 €"
  registro:  "https://mocilab.com/pages/registro-fc-barcelona-24k", // "Registrar mi 24K →" (tarjeta 24K Gold)
  tienda:    "https://mocilab.com",                                   // Tarjeta "www.mocilab.com con envío a casa"
  instagram: "https://www.instagram.com/explore/tags/spreadthejoy/",  // Muro #SpreadTheJoy
};
const OPEN_IN_NEW_TAB = true;

/* ---------- Asignar links ---------- */
document.querySelectorAll("[data-link]").forEach((el) => {
  const url = LINKS[el.dataset.link];
  if (!url) return;
  el.href = url;
  if (OPEN_IN_NEW_TAB) {
    el.target = "_blank";
    el.rel = "noopener";
  }
});
// "Empezar la colección" (banner) siempre va a la colección, aunque la plantilla sea una versión anterior
const heroCta = document.querySelector(".hero .btn--solid");
if (heroCta) {
  heroCta.href = LINKS.coleccion;
  heroCta.target = "_blank";
  heroCta.rel = "noopener";
}
// "Registrar mi 24K →" va a la página de registro, aunque la plantilla sea una versión anterior
document.querySelectorAll(".link-arrow").forEach((el) => {
  if (!el.textContent.includes("Registrar mi 24K")) return;
  el.href = LINKS.registro;
  el.target = "_blank";
  el.rel = "noopener";
});

/* ---------- Reveal al hacer scroll ---------- */
const reveals = document.querySelectorAll(".reveal");
if ("IntersectionObserver" in window) {
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-visible");
        io.unobserve(entry.target);
      });
    },
    { threshold: 0.15, rootMargin: "0px 0px -40px 0px" }
  );
  reveals.forEach((el) => io.observe(el));
} else {
  reveals.forEach((el) => el.classList.add("is-visible"));
}

/* ---------- Onda (ripple) al hacer click en botones ---------- */
document.querySelectorAll(".btn").forEach((btn) => {
  btn.addEventListener("pointerdown", (e) => {
    const rect = btn.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height);
    const dot = document.createElement("span");
    dot.className = "ripple";
    dot.style.width = dot.style.height = `${size}px`;
    dot.style.left = `${e.clientX - rect.left - size / 2}px`;
    dot.style.top = `${e.clientY - rect.top - size / 2}px`;
    btn.appendChild(dot);
    dot.addEventListener("animationend", () => dot.remove());
  });
});

/* ---------- Contador animado (34 / +8) ---------- */
const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
const counters = document.querySelectorAll("[data-count]");
if (!reduceMotion && "IntersectionObserver" in window) {
  const countIO = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        const target = Number(el.dataset.count);
        const start = performance.now();
        const duration = 1400;
        const tick = (now) => {
          const p = Math.min((now - start) / duration, 1);
          const eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(target * eased);
          if (p < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
        countIO.unobserve(el);
      });
    },
    { threshold: 0.6 }
  );
  counters.forEach((el) => {
    el.textContent = "0";
    countIO.observe(el);
  });
}

/* ---------- Chispas sobre la imagen del banner ----------
   Se dibujan en un <canvas> encima de la foto: la imagen no se toca.
   Coordenadas en píxeles de la imagen original (2000 × 913). */
const sparkCanvas = document.querySelector(".hero__sparkles");
if (sparkCanvas && !reduceMotion) {
  const IMG_W = 2000;
  const IMG_H = 913;
  const ctx = sparkCanvas.getContext("2d");

  // Destellos fijos: luces del estadio, bordes de monedas y esquinas de las cajas
  const GLINTS = [
    [40, 15, 1.1], [110, 45, 0.9], [175, 68, 1], [245, 96, 0.8], [305, 122, 1],
    [365, 145, 0.8], [440, 168, 0.9], [525, 202, 0.8], [592, 228, 1],
    [720, 265, 0.8], [810, 288, 0.9], [890, 310, 0.8], [975, 333, 0.9], [1045, 356, 0.8],
    [515, 650, 1], [655, 650, 1.2], [1690, 652, 1.2], [1858, 646, 1],
    [1072, 290, 1.1], [1444, 298, 0.9], [1702, 292, 1], [752, 428, 0.8],
    [250, 860, 0.6], [1990, 880, 0.6],
  ];

  // Zonas con texto de producto: nunca se dibuja encima
  const RECTS = [
    [740, 415, 1070, 840],   // caja de sobres
    [1060, 280, 1455, 850],  // álbum
    [1440, 285, 1715, 815],  // álbum abierto
    [120, 690, 480, 740],    // cartel FC BARCELONA del estadio
    [470, 820, 1960, 913],   // reflejos de los productos en el piso
  ];
  const CIRCLES = [
    [575, 725, 100], [735, 742, 125], [1760, 742, 125], [1900, 725, 100],
  ];
  const blocked = (x, y, pad = 0) =>
    RECTS.some(([x1, y1, x2, y2]) => x > x1 - pad && x < x2 + pad && y > y1 - pad && y < y2 + pad) ||
    CIRCLES.some(([cx, cy, r]) => (x - cx) ** 2 + (y - cy) ** 2 < (r + pad) ** 2);

  // Sprites precalculados (punto con brillo y estrella de 4 puntas)
  const makeSprite = (size, draw) => {
    const c = document.createElement("canvas");
    c.width = c.height = size;
    draw(c.getContext("2d"), size / 2);
    return c;
  };
  const dotSprite = makeSprite(64, (g, h) => {
    const grad = g.createRadialGradient(h, h, 0, h, h, h);
    grad.addColorStop(0, "rgba(255,248,220,1)");
    grad.addColorStop(0.25, "rgba(255,214,120,.8)");
    grad.addColorStop(1, "rgba(255,190,60,0)");
    g.fillStyle = grad;
    g.fillRect(0, 0, h * 2, h * 2);
  });
  const starSprite = makeSprite(128, (g, h) => {
    const glow = g.createRadialGradient(h, h, 0, h, h, h * 0.5);
    glow.addColorStop(0, "rgba(255,255,240,1)");
    glow.addColorStop(0.3, "rgba(255,225,150,.55)");
    glow.addColorStop(1, "rgba(255,200,80,0)");
    g.fillStyle = glow;
    g.fillRect(0, 0, h * 2, h * 2);
    g.fillStyle = "rgba(255,250,230,.95)";
    for (const rot of [0, Math.PI / 2]) {
      g.save();
      g.translate(h, h);
      g.rotate(rot);
      g.beginPath();
      g.moveTo(-h, 0);
      g.quadraticCurveTo(0, -h * 0.05, h, 0);
      g.quadraticCurveTo(0, h * 0.05, -h, 0);
      g.fill();
      g.restore();
    }
  });

  let scale = 1;
  let width = 0;
  let height = 0;
  const resize = () => {
    const rect = sparkCanvas.getBoundingClientRect();
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    width = rect.width;
    height = rect.height;
    scale = width / IMG_W;
    sparkCanvas.width = Math.round(width * dpr);
    sparkCanvas.height = Math.round(height * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  };
  new ResizeObserver(resize).observe(sparkCanvas);
  resize();

  const rand = (a, b) => a + Math.random() * (b - a);

  // Partículas doradas que suben (en coordenadas de la imagen)
  const spawnEmber = (anywhere) => {
    let x, y;
    do {
      x = rand(0, IMG_W);
      y = anywhere ? rand(0, IMG_H) : rand(IMG_H * 0.7, IMG_H + 20);
    } while (blocked(x, y, 20));
    return {
      x, y,
      vy: rand(8, 26),        // px de imagen por segundo
      drift: rand(6, 18),
      phase: rand(0, Math.PI * 2),
      size: rand(6, 16),
      life: 0,
      ttl: rand(5, 11),
    };
  };
  const embers = Array.from({ length: 55 }, () => spawnEmber(true));

  // Bokeh suave en el cielo
  const bokeh = Array.from({ length: 9 }, () => ({
    x: rand(950, 2000), y: rand(20, 260), r: rand(20, 55),
    vx: rand(-6, 6), phase: rand(0, Math.PI * 2), speed: rand(0.2, 0.5),
  }));

  const glints = GLINTS.map(([x, y, s]) => ({
    x, y, s, period: rand(2.6, 5.5), offset: rand(0, 6), rot: rand(0, Math.PI),
  }));

  let last = performance.now();
  let running = true;
  const frame = (now) => {
    if (!running) return;
    const dt = Math.min((now - last) / 1000, 0.05);
    last = now;
    const t = now / 1000;
    ctx.clearRect(0, 0, width, height);
    ctx.globalCompositeOperation = "lighter";

    // Bokeh
    for (const b of bokeh) {
      b.x += b.vx * dt;
      if (b.x < 900) b.x = 2000; else if (b.x > 2050) b.x = 950;
      const a = 0.06 + 0.06 * Math.sin(t * b.speed + b.phase);
      const r = b.r * scale;
      ctx.globalAlpha = a;
      ctx.drawImage(dotSprite, b.x * scale - r, b.y * scale - r, r * 2, r * 2);
    }

    // Partículas
    for (let i = 0; i < embers.length; i++) {
      const e = embers[i];
      e.life += dt;
      e.y -= e.vy * dt;
      const x = e.x + Math.sin(t * 0.8 + e.phase) * e.drift;
      if (e.life > e.ttl || e.y < -20) { embers[i] = spawnEmber(false); continue; }
      if (blocked(x, e.y, 14)) continue; // pasa "por detrás" del producto
      const fade = Math.min(e.life / 1.2, 1, (e.ttl - e.life) / 1.5);
      const twinkle = 0.55 + 0.45 * Math.sin(t * 6 + e.phase * 3);
      const size = e.size * scale * (0.8 + 0.4 * twinkle);
      ctx.globalAlpha = Math.max(0, fade * twinkle * 0.85);
      ctx.drawImage(dotSprite, x * scale - size, e.y * scale - size, size * 2, size * 2);
    }

    // Destellos
    for (const g of glints) {
      const p = ((t + g.offset) % g.period) / g.period;
      if (p > 0.22) continue;                 // breve destello y pausa
      const k = Math.sin((p / 0.22) * Math.PI); // 0 → 1 → 0
      const size = (34 + 30 * g.s) * scale * k;
      ctx.globalAlpha = k;
      ctx.save();
      ctx.translate(g.x * scale, g.y * scale);
      ctx.rotate(g.rot + t * 0.6);
      ctx.drawImage(starSprite, -size, -size, size * 2, size * 2);
      ctx.restore();
    }

    // Borra cualquier brillo que haya caído sobre los productos: los textos quedan intactos
    ctx.globalAlpha = 1;
    ctx.globalCompositeOperation = "destination-out";
    ctx.beginPath();
    for (const [x1, y1, x2, y2] of RECTS) ctx.rect(x1 * scale, y1 * scale, (x2 - x1) * scale, (y2 - y1) * scale);
    ctx.fill();
    for (const [cx, cy, r] of CIRCLES) {
      ctx.beginPath();
      ctx.arc(cx * scale, cy * scale, (r - 18) * scale, 0, Math.PI * 2); // cara de la moneda; el borde puede brillar
      ctx.fill();
    }
    ctx.globalCompositeOperation = "source-over";
    requestAnimationFrame(frame);
  };

  // Solo anima cuando el banner está a la vista
  new IntersectionObserver(([entry]) => {
    const visible = entry.isIntersecting;
    if (visible && !running) {
      running = true;
      last = performance.now();
      requestAnimationFrame(frame);
    } else if (!visible) {
      running = false;
    }
  }).observe(sparkCanvas);
  requestAnimationFrame(frame);
}
